// extracted by mini-css-extract-plugin
export default {"container":"onboarding_container__8Zbm-","button":"onboarding_button__Bft-9","heading":"onboarding_heading__4ikQV","form":"onboarding_form__z-YNE"};